<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/admin/home">
        <img
          class="navbar-brand-full ml-2"
          src="img/logo-CDLQGVN.png"
          width="auto"
          height="90%"
          alt="Logo"
        />
        <img
          class="navbar-brand-minimized ml-2"
          src="img/logo5.png"
          width="auto"
          height="80%"
          alt="Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none hidden" display="lg" />
      <!-- <SidebarMinimizer class="d-md-down-none" display="lg" /> -->
      <!-- <b-navbar-nav class="d-md-down-none">
            <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
            <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
            <b-nav-item class="px-3">Settings</b-nav-item>
          </b-navbar-nav>-->
      <b-navbar-nav class="ml-auto">
        <!-- list icon -->
        <!-- <b-nav-item class="d-md-down-none">
              <i class="icon-bell icons"></i>
              <b-badge pill letiant="danger">5</b-badge>
            </b-nav-item>-->
        <!-- <b-nav-item class="d-md-down-none">
              <i class="icon-list"></i>
            </b-nav-item>
            <b-nav-item class="d-md-down-none">
              <i class="icon-location-pin"></i>
            </b-nav-item>-->

        <!-- account -->
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>

      <!-- menu right -->
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!-- <AsideToggler class="d-lg-none" mobile /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav" :defaultOpen="true"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb :list="list"/> -->
        <div class="container-fluid">
          <router-view :key="$route.name"></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <!-- <DefaultAside /> -->
      </AppAside>
    </div>

    <!--footer-->
    <TheFooter>
      <div class="text-center footer" style="width: 100%">
        <h5
          style="
            color: white;
            margin-bottom: 0px;
            font-family: 'Times New Roman';
            font-weight: bold;
          "
        >
          THÔNG TIN LIÊN HỆ, HỖ TRỢ:
        </h5>
        <p style="color: white; font-family: 'Times New Roman'; margin: 0">
          Điện thoại:
          <a style="color: #ffffff" href="tel:19006888">1900 6888</a>; Email:
          <a style="color: #ffffff" href="mailto:info@vietsens.vn"
            >info@vietsens.vn</a
          >;
        </p>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import MethodService from "../service/MethodService";
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
// import ApiService from "../service/ApiService";
import DataService from "../service/DataService";
import DonViCungCapChoDuyetApi from "@/moduleApi/DonViCungCapChoDuyetApi";
import TourDuLichChoDuyetApi from "@/moduleApi/TourDuLichChoDuyetApi";
import DDATApi from "@/moduleApi/DDATApi";
import DonViCungCapApi from "@/moduleApi/DonViCungCapApi";
import QuangCaoApi from "@/moduleApi/QuangCaoApi";
import DichVuChoDuyetApi from "@/moduleApi/DichVuChoDuyetApi";
import mushroom from "../service/api/dulich-api";
import { Filter } from "mushroomjs";
export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      nav: [],
      navNew: [],
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      loaiHinhRegister: DataService.loaiHinhRegister,
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate();
    },

    // Change menu name dynamically
    fn_changeCorrespondingMenuName(loai, arrNav) {
      // const objLoai = this.loaiHinhRegister.find(item => item.code === loai);
      // console.log("LOAI", objLoai)
      let routeName = "Lưu trú";
      if (loai === "international_travel" || loai === "domestic_travel") {
        routeName = "Dịch vụ lữ hành";
      } else if (loai === "tourist_area" || loai === "tourist_attraction") {
        routeName = "Khu, điểm du lịch";
      } else if (loai === "shopping") {
        routeName = "Điểm mua sắm";
      }

      arrNav.forEach((nav) => {
        if (nav.url == "/admin/BaiDangDichVu/LuuTru") {
          nav.name = routeName;
          return;
        }
      });
    },

    async fn_getNav() {
      let currentUser = MethodService.getCurrentUser();
      // let arrNav = this.nav;
      let arrNav = MethodService.copyObject(nav.items);
      // Change menu name dynamically
      const loai = window.localStorage.getItem("loai");
      if (loai) {
        this.fn_changeCorrespondingMenuName(loai, arrNav);
      }
      arrNav.forEach((valueNarLever1) => {
        if (
          valueNarLever1.meta.allowAccess &&
          valueNarLever1.meta.allowAccess.length > 0
        ) {
          //check quyền truy cập Nav1
          valueNarLever1.meta.allowAccess.forEach((valueMetaLever1) => {
            if (
              currentUser.roles.indexOf(valueMetaLever1) != -1 ||
              valueMetaLever1 == "*"
            ) {
              valueNarLever1.meta.allow = true;
            }
          });
          //check xem tồn tại Nav2
          if (valueNarLever1.children && valueNarLever1.children.length > 0) {
            valueNarLever1.children.forEach((valueNarLever2) => {
              if (
                valueNarLever2.meta.allowAccess &&
                valueNarLever2.meta.allowAccess.length > 0
              ) {
                //check quyền truy cập Nav2
                valueNarLever2.meta.allowAccess.forEach((valueMetaLever2) => {
                  if (
                    currentUser.roles.indexOf(valueMetaLever2) != -1 ||
                    valueMetaLever2 == "*"
                  ) {
                    valueNarLever2.meta.allow = true;
                  }
                });
                //check xem tồn tại Nav3
                if (
                  valueNarLever2.children &&
                  valueNarLever2.children.length > 0
                ) {
                  valueNarLever2.children.forEach((valueNarLever3) => {
                    if (
                      valueNarLever3.meta.allowAccess &&
                      valueNarLever3.meta.allowAccess.length > 0
                    ) {
                      //check quyền truy cập Nav3
                      valueNarLever3.meta.allowAccess.forEach(
                        (valueMetaLever3) => {
                          if (
                            currentUser.roles.indexOf(valueMetaLever3) != -1 ||
                            valueMetaLever3 == "*"
                          ) {
                            valueNarLever3.meta.allow = true;
                          }
                        }
                      );
                      //Mở rộng thêm ở đây
                    }
                  });
                }
              }
            });
          }
        }
      });
      //Check Lọc quyền Nav1 và trả về mảng đã lọc arrNavFilter
      let arrNavFilter = arrNav.filter(function (value) {
        return value.meta.allow;
      });
      arrNavFilter.forEach((valueNavF1) => {
        //check tồn tại Nav2
        if (valueNavF1.children && valueNavF1.children.length > 0) {
          // Lọc quyền Nav2 và trả về mảng đã lọc arrNavFilter2
          let arrNavFilter2 = valueNavF1.children.filter(function (value2) {
            return value2.meta.allow;
          });
          //gán mảng Nav2 đã lọc vào mảng mẹ
          valueNavF1.children = arrNavFilter2;
          (arrNavFilter2.children || []).forEach((valueNavF2) => {
            //check tồn tại Nav3
            if (valueNavF2.children && valueNavF2.children.length > 0) {
              // Lọc quyền Nav3 và trả về mảng đã lọc arrNavFilter3
              let arrNavFilter3 = valueNavF2.children.filter(function (value3) {
                return value3.meta.allow;
              });
              //gán mảng Nav3 đã lọc vào mảng mẹ
              valueNavF2.children = arrNavFilter3;
              // Mở rộng tiếp theo ở đây
            }
          });
        }
      });
      // loc theo da co don cc hya chua\
      if (currentUser.roles.includes("SafePlace")) {
        const diemDenAnToanRes = await DDATApi.list({
          filters: "nguoi_tao_id=" + this.currentUser.id,
        });
        if (!diemDenAnToanRes.result || diemDenAnToanRes.result.length === 0) {
          this.nav = arrNavFilter;
          return;
        }
        const donViCungCapRes = await DonViCungCapApi.findById(
          diemDenAnToanRes.result[0].id
        );
        const donViCungCapChoDuyetRes = await DonViCungCapChoDuyetApi.findById(
          diemDenAnToanRes.result[0].id
        );
        const URLCanDonViCungCap = [
          "/admin/PhanHoi/list",
          "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/VeDienTu",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/AutomaticCommentary",
          "/admin/BaiDangDichVu/VanTaiKhach",
        ];
        const URLLuuTru = [
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/VeDienTu",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/BaiDangDichVu/VanTaiKhach",
        ];
        const URLAmThuc = [
          "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/VeDienTu",
          "/admin/BaiDangDichVu/VanTaiKhach",
        ];
        const URLDiemDen = [
          "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/VeDienTu",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/BaiDangDichVu/VanTaiKhach",
        ];
        const URLGiaiTri = [
          "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/VeDienTu",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/BaiDangDichVu/VanTaiKhach",
        ];
        const URLVeDienTu = [
          "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/BaiDangDichVu/VanTaiKhach",
        ];
        const URLVanTaiKhach = [
          "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/BaiDangDichVu/VeDienTu",
        ];
        const URLVeMayBay = [
          "/admin/PhanHoi/list",
          "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/BaiDangDichVu/VeDienTu",
        ];
        const URLVeDienTuChoDuyet = ["/admin/BaiDangDichVu/VeDienTu/history"];
        const URLAccountDuLich = ["/admin/ThongTinDDAT/detail"];
        const URLSafePlaceWithoutTypeOfStay = [
          // "/admin/DuLieuAnToanHangNgay",
          // "/admin/DanhGiaAnToanHangNgay/day",
          // "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/BaiDangDichVu/VeDienTu",
          "/admin/BaiDangDichVu/VanTaiKhach",
        ];
        // Khu du lịch (tourist_area): vẫn hiển thị đầy đủ menu của Lưu trú (khách sạn)
        // và Ẩm thực (nhà hàng), task 57919
        const URLSafePlaceTouristArea = [
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/VeDienTu",
          "/admin/BaiDangDichVu/VanTaiKhach",
        ];
        const URLSafePlaceInActive = [
          // "/admin/DuLieuAnToanHangNgay",
          "/admin/PhanHoi/list",
          // "/admin/DanhGiaAnToanHangNgay/day",
          "/admin/BaiDangDichVu/GiaiTri",
          "/admin/BaiDangDichVu/LuuTru",
          "/admin/BaiDangDichVu/DiemDen",
          "/admin/BaiDangDichVu/AmThuc",
          "/admin/BaiDangDichVu/VeDienTu",
          "/admin/AutomaticCommentary/list",
        ];
        if (
          currentUser.roles.includes("SafePlace") &&
          (donViCungCapRes.result == null ||
            donViCungCapRes.result == undefined ||
            !donViCungCapRes.result.loai)
        ) {
          const arrNavFilter4 = arrNavFilter.filter(
            (x) => !URLCanDonViCungCap.includes(x.url)
          );
          arrNavFilter = arrNavFilter4;
        } else if (
          currentUser.roles.includes("SafePlace") &&
          diemDenAnToanRes.result[0].loai_diem_den == "hotel"
        ) {
          const arrNavFilter6 = arrNavFilter.filter(
            (x) => !URLLuuTru.includes(x.url)
          );
          arrNavFilter = arrNavFilter6;
        } else if (
          currentUser.roles.includes("SafePlace") &&
          diemDenAnToanRes.result[0].loai_diem_den == "restaurant"
        ) {
          const arrNavFilter7 = arrNavFilter.filter(
            (x) => !URLAmThuc.includes(x.url)
          );
          arrNavFilter = arrNavFilter7;
        } else if (
          currentUser.roles.includes("SafePlace") &&
          diemDenAnToanRes.result[0].loai_diem_den == "yellow_page_place"
        ) {
          const arrNavFilter8 = arrNavFilter.filter(
            (x) => !URLDiemDen.includes(x.url)
          );
          arrNavFilter = arrNavFilter8;
        } else if (
          currentUser.roles.includes("SafePlace") &&
          diemDenAnToanRes.result[0].loai_diem_den == "entertainment"
        ) {
          const arrNavFilter9 = arrNavFilter.filter(
            (x) => !URLGiaiTri.includes(x.url)
          );
          arrNavFilter = arrNavFilter9;
        } else if (
          currentUser.roles.includes("SafePlace") &&
          diemDenAnToanRes.result[0].loai_diem_den == "ticket"
        ) {
          let arrNavFilter10 = [];
          let arrNavFilter11 = [];
          if (
            donViCungCapRes.result &&
            donViCungCapRes.result.ve_dien_tu &&
            donViCungCapRes.result.ve_dien_tu.loai == "show_ticket"
          ) {
            arrNavFilter10 = arrNavFilter.filter(
              (x) => !URLVeDienTu.includes(x.url)
            );
            arrNavFilter = arrNavFilter10;
          } else {
            arrNavFilter10 = arrNavFilter.filter(
              (x) => !URLVeMayBay.includes(x.url)
            );
            arrNavFilter11 = arrNavFilter10.map((x) => {
              if (x.children) {
                x.children = x.children.filter(
                  (y) => !URLVeDienTuChoDuyet.includes(y.url)
                );
              }
              return x;
            });
            arrNavFilter = arrNavFilter11;
          }
        } else if (
          currentUser.roles.includes("SafePlace") &&
          diemDenAnToanRes.result[0].loai_diem_den == "tourist_carriers"
        ) {
          const arrNavFilter1 = arrNavFilter.filter(
            (x) => !URLVanTaiKhach.includes(x.url)
          );
          arrNavFilter = arrNavFilter1;
        }
        // console.log('arrNavFilter111', JSON.parse(JSON.stringify(arrNavFilter)))
        if (diemDenAnToanRes.result[0].thong_tin_chung.nguon != "trang_vang") {
          if (!donViCungCapRes.result && !donViCungCapChoDuyetRes.result) {
            const arrNavFilter12 = arrNavFilter.filter(
              (x) => !URLAccountDuLich.includes(x.url)
            );
            arrNavFilter = arrNavFilter12;
          }
        }
        // console.log('arrNavFilter333', JSON.parse(JSON.stringify(arrNavFilter)))

        if (
          diemDenAnToanRes.result[0].hoat_dong &&
          diemDenAnToanRes.result[0].hoat_dong.ngung_hoat_dong
        ) {
          const arrNavFilter13 = arrNavFilter.filter(
            (x) => !URLSafePlaceInActive.includes(x.url)
          );
          arrNavFilter = arrNavFilter13;
        }

        const dsLoaiDiemDenCoMenu = [
          "hotel",
          "tourist_villa",
          "tourist_apartment",
          "tourist_cruise",
          "motel",
          "homestay",
          "restaurant",
          "entertainment",
          "tourist_carriers",
        ];
        const loaiDiemDen = diemDenAnToanRes.result[0].loai_diem_den;
        if (loaiDiemDen === "tourist_area") {
          // Khu du lịch: giữ đầy đủ menu Lưu trú (khách sạn) và Ẩm thực (nhà hàng), task 57919
          const arrNavFilter13 = arrNavFilter.filter(
            (x) => !URLSafePlaceTouristArea.includes(x.url)
          );
          arrNavFilter = arrNavFilter13;
        } else if (!dsLoaiDiemDenCoMenu.includes(loaiDiemDen)) {
          const arrNavFilter13 = arrNavFilter.filter(
            (x) => !URLSafePlaceWithoutTypeOfStay.includes(x.url)
          );
          arrNavFilter = arrNavFilter13;
        }
        //Check tài khoản điểm đến có Merchant hay không
        let arrSignUpBankAccount = ["/admin/SignUpBankAccount"];
        if (
          diemDenAnToanRes.result &&
          diemDenAnToanRes.result[0] &&
          diemDenAnToanRes.result[0].merchant &&
          diemDenAnToanRes.result[0].merchant.enabled === true
        ) {
          const arrNavFilter14 = arrNavFilter.filter(
            (x) => !arrSignUpBankAccount.includes(x.url)
          );
          arrNavFilter = arrNavFilter14;
        }
        // Check Khách hàng thân thiết
        let arrSignUpBankAccount2 = ["/admin/SignUpBankAccount-2"];
        if (
          diemDenAnToanRes.result &&
          diemDenAnToanRes.result[0] &&
          (!diemDenAnToanRes.result[0].merchant ||
            (diemDenAnToanRes.result[0].merchant &&
              diemDenAnToanRes.result[0].merchant.enabled === false))
        ) {
          const arrNavFilter14 = arrNavFilter.filter(
            (x) => !arrSignUpBankAccount2.includes(x.url)
          );
          arrNavFilter = arrNavFilter14;
        }
      }
      // Gán mảng mẹ vào Nav Main
      this.nav = arrNavFilter;
      // console.log('arrNavFilter222', JSON.parse(JSON.stringify(arrNavFilter)))
    },
    async fn_countPhanHoi() {
      let currentUser = MethodService.getCurrentUser();
      let filter = "trang_thai=new";
      if (MethodService.checkRole("TCQLTT")) {
        filter =
          "tcqltt.trang_thai=new&tcqltt.nguoi_xu_ly_id=" + currentUser.id;
      }
      const res = await mushroom.phan_hoi.listAsync({
        filters: filter,
        limit: 1,
      });
      let total = res.meta.total || 0;

      (this.nav || []).forEach((item) => {
        if (item.code == "PhanHoi") {
          item.badge.text = total;
          this.forceUpdateUI();
        }
      });
    },
    // async fn_countPhanHoi() {
    //   this.dontLoading = true;
    //   let currentUser = MethodService.getCurrentUser();
    //   let filterPhanHoi = "";
    //   if (
    //     MethodService.checkRole("Officer") ||
    //     MethodService.checkRole("Admin") ||
    //     MethodService.checkRole("TrangVangContentManager")
    //   ) {
    //     filterPhanHoi = "?trang_thai=new";
    //   } else if (MethodService.checkRole("SafePlace")) {
    //     const nhomPhanHoiRes = await ApiService.get(
    //       config.hostApiDuLich + "nhom_phan_hois?loai=trang_vang",
    //       {}
    //     );
    //     let nhomPhanHoiIds = nhomPhanHoiRes.result.map((id) => id.id);
    //     let arrNhomPhanHoiIds =
    //       MethodService.findListItemDifferent(nhomPhanHoiIds);
    //     // filterPhanHoi = "?trang_thai=new&nhom_phan_hoi:in:" + arrNhomPhanHoiIds.join(",");
    //     filterPhanHoi = "?trang_thai=new";
    //   } else if (MethodService.checkRole("TourAgent")) {
    //     const nhomPhanHoiRes = await ApiService.get(
    //       config.hostApiDuLich + "nhom_phan_hois?loai=trang_vang",
    //       {}
    //     );
    //     let nhomPhanHoiIds = nhomPhanHoiRes.result.map((id) => id.id);
    //     let arrNhomPhanHoiIds =
    //       MethodService.findListItemDifferent(nhomPhanHoiIds);
    //     filterPhanHoi =
    //       "?trang_thai=new&&cong_ty_lu_hanh_id:is_null:false&cong_ty_lu_hanh_id=$$cong_ty_lu_hanh_id&nhom_phan_hoi:in:" +
    //       arrNhomPhanHoiIds.join(",");
    //   } else if (MethodService.checkRole("TCQLTT")) {
    //     filterPhanHoi =
    //       "?tcqltt.trang_thai=new&tcqltt.nguoi_xu_ly_id=" + currentUser.id;
    //   }

    //   let res = await ApiService.get(
    //     config.hostApiDuLich + "phan_hois/" + filterPhanHoi
    //   );
    //   (this.nav || []).forEach((item) => {
    //     if (item.code == "PhanHoi") {
    //       item.badge.text = res.meta.total;
    //       this.forceUpdateUI();
    //     }
    //   });
    // },

    fn_recountPhanHoi() {
      window.reqIntervalPhanHoi = setInterval(() => {
        this.fn_countPhanHoi();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countDiemDen() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=yellow_page_place&ready=true",
      };
      let res = await DichVuChoDuyetApi.list(dataFilter);
      if (MethodService.checkRole("SafePlace")) {
        (this.nav || []).forEach((item) => {
          if (item.children) {
            (item.children || []).forEach((items) => {
              if (items.code == "DiemDenSafePlace") {
                items.badge.text = res.meta.total;
                this.forceUpdateUI();
              }
            });
          }
        });
      } else {
        (this.nav || []).forEach((item) => {
          (item.children || []).forEach((items) => {
            (items.children || []).forEach((itemss) => {
              if (itemss.code == "DiemDen") {
                itemss.badge.text = res.meta.total;
                this.forceUpdateUI();
              }
            });
          });
        });
      }
    },

    fn_recountDiemDen() {
      window.reqIntervalDiemDen = setInterval(() => {
        this.fn_countDiemDen();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countTour() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "ready=true",
      };
      let res = await TourDuLichChoDuyetApi.list(dataFilter);
      if (MethodService.checkRole("TourAgent")) {
        (this.nav || []).forEach((item) => {
          (item.children || []).forEach((items) => {
            if (items.code == "TourDuLich") {
              items.badge.text = res.meta.total;
              this.forceUpdateUI();
            }
          });
        });
      } else {
        (this.nav || []).forEach((item) => {
          (item.children || []).forEach((items) => {
            (items.children || []).forEach((itemss) => {
              if (itemss.code == "TourDuLich") {
                itemss.badge.text = res.meta.total;
                this.forceUpdateUI();
              }
            });
          });
        });
      }
    },

    fn_recountTour() {
      window.reqIntervalTour = setInterval(() => {
        this.fn_countTour();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countLuuTru() {
      this.dontLoading = true;
      let dataFilter = {
        filters: Filter.and(
          Filter.or(Filter.eq("loai", "hotel"), Filter.eq("loai", "tourist_area")),
          Filter.isNull("duyet.duoc_duyet", true),
          Filter.isNull("luu_tru.ten", false)
        ).build(),
      };
      let res = await DichVuChoDuyetApi.list(dataFilter);
      if (MethodService.checkRole("SafePlace")) {
        if (this.nav) {
          (this.nav || []).forEach((item) => {
            if (item.children) {
              (item.children || []).forEach((items) => {
                if (items.code == "LuuTruSafePlace") {
                  items.badge.text = res.meta.total;
                  this.forceUpdateUI();
                }
              });
            }
          });
        }
      } else {
        (this.nav || []).forEach((item) => {
          (item.children || []).forEach((items) => {
            (items.children || []).forEach((itemss) => {
              if (itemss.code == "LuuTru") {
                itemss.badge.text = res.meta.total;
                this.forceUpdateUI();
              }
            });
          });
        });
      }
    },

    fn_recountLuuTru() {
      window.reqIntervalLuuTru = setInterval(() => {
        this.fn_countLuuTru();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countAmThuc() {
      this.dontLoading = true;
      let dataFilter = {
        filters: Filter.and(
          Filter.or(Filter.eq("loai","restaurant"), Filter.eq("loai","tourist_area")),
          Filter.isNull("duyet.duoc_duyet", true),
          Filter.isNull("am_thuc.ten", false)
        ).build(),
      };
      let res = await DichVuChoDuyetApi.list(dataFilter);
      if (MethodService.checkRole("SafePlace")) {
        if (this.nav) {
          (this.nav || []).forEach((item) => {
            if (item.children) {
              (item.children || []).forEach((items) => {
                if (items.code == "AmThucSafePlace") {
                  items.badge.text = res.meta.total;
                  this.forceUpdateUI();
                }
              });
            }
          });
        }
      } else {
        (this.nav || []).forEach((item) => {
          (item.children || []).forEach((items) => {
            (items.children || []).forEach((itemss) => {
              if (itemss.code == "AmThuc") {
                itemss.badge.text = res.meta.total;
                this.forceUpdateUI();
              }
            });
          });
        });
      }
    },

    fn_recountAmThuc() {
      window.reqIntervalAmThuc = setInterval(() => {
        this.fn_countAmThuc();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countGiaiTri() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=entertainment&ready=true",
      };
      let res = await DichVuChoDuyetApi.list(dataFilter);
      if (MethodService.checkRole("SafePlace")) {
        if (this.nav) {
          (this.nav || []).forEach((item) => {
            if (item.children) {
              (item.children || []).forEach((items) => {
                if (items.code == "GiaiTriSafePlace") {
                  items.badge.text = res.meta.total;
                  this.forceUpdateUI();
                }
              });
            }
          });
        }
      } else {
        (this.nav || []).forEach((item) => {
          (item.children || []).forEach((items) => {
            (items.children || []).forEach((itemss) => {
              if (itemss.code == "GiaiTri") {
                itemss.badge.text = res.meta.total;
                this.forceUpdateUI();
              }
            });
          });
        });
      }
    },

    fn_recountGiaiTri() {
      window.reqIntervalGiaiTri = setInterval(() => {
        this.fn_countGiaiTri();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countVeDienTu() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=ticket&ready=true&ve_dien_tu.loai=show_ticket",
      };
      let res = await DichVuChoDuyetApi.list(dataFilter);
      if (MethodService.checkRole("SafePlace")) {
        if (this.nav) {
          (this.nav || []).forEach((item) => {
            if (item.children) {
              (item.children || []).forEach((items) => {
                if (items.code == "VeNgheThuatBieuDienSafePlace") {
                  items.badge.text = res.meta.total;
                  this.forceUpdateUI();
                }
              });
            }
          });
        }
      } else {
        (this.nav || []).forEach((item) => {
          (item.children || []).forEach((items) => {
            (items.children || []).forEach((itemss) => {
              if (itemss.code == "VeNgheThuatBieuDien") {
                itemss.badge.text = res.meta.total;
                this.forceUpdateUI();
              }
            });
          });
        });
      }
    },

    fn_recountVeDienTu() {
      window.reqIntervalVeDienTu = setInterval(() => {
        this.fn_countVeDienTu();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countVanTaiKhach() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=tourist_carriers&ready=true",
      };
      let res = await DichVuChoDuyetApi.list(dataFilter);
      if (MethodService.checkRole("SafePlace")) {
        if (this.nav) {
          (this.nav || []).forEach((item) => {
            if (item.children) {
              (item.children || []).forEach((items) => {
                if (items.code == "VanTaiKhachSafePlace") {
                  items.badge.text = res.meta.total;
                  this.forceUpdateUI();
                }
              });
            }
          });
        }
      } else {
        (this.nav || []).forEach((item) => {
          (item.children || []).forEach((items) => {
            (items.children || []).forEach((itemss) => {
              if (itemss.code == "VanTaiKhach") {
                itemss.badge.text = res.meta.total;
                this.forceUpdateUI();
              }
            });
          });
        });
      }
    },
    fn_recountVanTaiKhach() {
      window.reqIntervalVanTaiKhach = setInterval(() => {
        this.fn_countVanTaiKhach();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countDichVuDiemDen() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=yellow_page_place&duyet.duoc_duyet:is_null:true",
      };
      let res = await DonViCungCapChoDuyetApi.list(dataFilter);
      (this.nav || []).forEach((item) => {
        (item.children || []).forEach((items) => {
          (items.children || []).forEach((itemss) => {
            if (itemss.code == "DichVuDiemDen") {
              itemss.badge.text = res.meta.total;
              this.forceUpdateUI();
            }
          });
        });
      });
    },
    fn_recountDichVuDiemDen() {
      window.reqIntervalDichVuDiemDen = setInterval(() => {
        this.fn_countDichVuDiemDen();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countDichVuLuuTru() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=hotel&duyet.duoc_duyet:is_null:true",
      };
      let res = await DonViCungCapChoDuyetApi.list(dataFilter);
      (this.nav || []).forEach((item) => {
        (item.children || []).forEach((items) => {
          (items.children || []).forEach((itemss) => {
            if (itemss.code == "DichVuLuuTru") {
              itemss.badge.text = res.meta.total;
              this.forceUpdateUI();
            }
          });
        });
      });
    },
    fn_recountDichVuLuuTru() {
      window.reqIntervalDichVuLuuTru = setInterval(() => {
        this.fn_countDichVuLuuTru();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countDichVuAmThuc() {
      this.dontLoading = true;
      let dataFilter = {
        filters: Filter.and(
          Filter.or(Filter.eq("loai","restaurant"), Filter.eq("loai","tourist_area")),
          Filter.isNull("duyet.duoc_duyet", true),
          Filter.isNull("am_thuc.ten", false)
        ).build(),
      };
      let res = await DonViCungCapChoDuyetApi.list(dataFilter);
      (this.nav || []).forEach((item) => {
        (item.children || []).forEach((items) => {
          (items.children || []).forEach((itemss) => {
            if (itemss.code == "DichVuAmThuc") {
              itemss.badge.text = res.meta.total;
              this.forceUpdateUI();
            }
          });
        });
      });
    },
    fn_recountDichVuAmThuc() {
      window.reqIntervalDichVuAmThuc = setInterval(() => {
        this.fn_countDichVuAmThuc();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countDichVuGiaiTri() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=entertainment&duyet.duoc_duyet:is_null:true",
      };
      let res = await DonViCungCapChoDuyetApi.list(dataFilter);
      (this.nav || []).forEach((item) => {
        (item.children || []).forEach((items) => {
          (items.children || []).forEach((itemss) => {
            if (itemss.code == "DichVuGiaiTri") {
              itemss.badge.text = res.meta.total;
              this.forceUpdateUI();
            }
          });
        });
      });
    },
    fn_recountDichVuGiaiTri() {
      window.reqIntervalDichVuGiaiTri = setInterval(() => {
        this.fn_countDichVuGiaiTri();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countDichVuVeDienTu() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=ticket&duyet.duoc_duyet:is_null:true",
      };
      let res = await DonViCungCapChoDuyetApi.list(dataFilter);
      (this.nav || []).forEach((item) => {
        if (item.children) {
          (item.children || []).forEach((items) => {
            if (items.children) {
              (items.children || []).forEach((itemss) => {
                if (itemss.code == "DichVuVeDienTu") {
                  itemss.badge.text = res.meta.total;
                  this.forceUpdateUI();
                }
              });
            }
          });
        }
      });
    },
    fn_recountDichVuVeDienTu() {
      window.reqIntervalDichVuVeDienTu = setInterval(() => {
        this.fn_countDichVuVeDienTu();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countDichVuVanTaiKhach() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "loai=tourist_carriers&duyet.duoc_duyet:is_null:true",
      };
      let res = await DonViCungCapChoDuyetApi.list(dataFilter);
      (this.nav || []).forEach((item) => {
        (item.children || []).forEach((items) => {
          (items.children || []).forEach((itemss) => {
            if (itemss.code == "DichVuVanTaiKhach") {
              itemss.badge.text = res.meta.total;
              this.forceUpdateUI();
            }
          });
        });
      });
    },
    fn_recountDichVuVanTaiKhach() {
      window.reqIntervalDichVuVanTaiKhach = setInterval(() => {
        this.fn_countDichVuVanTaiKhach();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_countAds() {
      this.dontLoading = true;
      let dataFilter = {
        filters: "trang_thai=1",
      };
      let res1 = await QuangCaoApi.list(dataFilter);
      (this.nav || []).forEach((item) => {
        (item.children || []).forEach((items) => {
          if (items.code == "QuangCao") {
            items.badge.text = res1.meta.total;
            this.forceUpdateUI();
          }
        });
      });
    },

    fn_recountAds() {
      window.reqIntervalAds = setInterval(() => {
        this.fn_countAds();
      }, 2000000); //15phut ~ 1200000s :  1phut ~ 60000s
    },

    async fn_checkHaveDVCC() {
      let diemDenAnToanRes = await DDATApi.list({
        filters: "nguoi_tao_id=" + this.currentUser.id,
      });
      if (
        diemDenAnToanRes.result[0].loai_diem_den == "restaurant" ||
        diemDenAnToanRes.result[0].loai_diem_den == "hotel" ||
        diemDenAnToanRes.result[0].loai_diem_den == "entertainment" ||
        diemDenAnToanRes.result[0].loai_diem_den == "ticket" ||
        diemDenAnToanRes.result[0].loai_diem_den == "tourist_villa" ||
        diemDenAnToanRes.result[0].loai_diem_den == "tourist_apartment" ||
        diemDenAnToanRes.result[0].loai_diem_den == "camping" ||
        diemDenAnToanRes.result[0].loai_diem_den == "motel" ||
        diemDenAnToanRes.result[0].loai_diem_den == "homestay" ||
        diemDenAnToanRes.result[0].loai_diem_den == "tourist_cruise"
      ) {
        this.$router.push({
          name: "Admin-ChinhSachVaQuyenLoi-infomation",
        });
      } else {
        window.toastr.warning("Loại điểm đến không thuộc trang vàng!");
      }
    },
  },
  async created() {
    await this.fn_getNav();
    const diemDenAnToanRes = await DDATApi.list({
      filters: "nguoi_tao_id=" + this.currentUser.id,
    });

    if (MethodService.checkRole("Admin, Officer, TCQLTT, VNATAdmin")) {
      this.fn_countPhanHoi();
      this.fn_recountPhanHoi();

      this.fn_countDiemDen();
      this.fn_recountDiemDen();

      this.fn_countTour();
      this.fn_recountTour();

      this.fn_countLuuTru();
      this.fn_recountLuuTru();

      this.fn_countAmThuc();
      this.fn_recountAmThuc();

      this.fn_countGiaiTri();
      this.fn_recountGiaiTri();

      this.fn_countVeDienTu();
      this.fn_recountVeDienTu();

      this.fn_countVanTaiKhach();
      this.fn_recountVanTaiKhach();

      this.fn_countDichVuDiemDen();
      this.fn_recountDichVuDiemDen();

      this.fn_countDichVuLuuTru();
      this.fn_recountDichVuLuuTru();

      this.fn_countDichVuAmThuc();
      this.fn_recountDichVuAmThuc();

      this.fn_countDichVuGiaiTri();
      this.fn_recountDichVuGiaiTri();

      this.fn_countDichVuVeDienTu();
      this.fn_recountDichVuVeDienTu();

      this.fn_countDichVuVanTaiKhach();
      this.fn_recountDichVuVanTaiKhach();

      this.fn_countAds();
      this.fn_recountAds();
    } else if (
      MethodService.checkRole("TrangVangContentManager") ||
      MethodService.checkRole("SafePlace")
    ) {
      this.fn_countPhanHoi();
      this.fn_recountPhanHoi();

      if (diemDenAnToanRes.result && diemDenAnToanRes.result[0]) {
        const loaiDiemDen = diemDenAnToanRes.result[0].loai_diem_den;
        if (loaiDiemDen == "restaurant" || loaiDiemDen == "tourist_area") {
          this.fn_countAmThuc();
          this.fn_recountAmThuc();
        }
        if (loaiDiemDen == "hotel" || loaiDiemDen == "tourist_area") {
          this.fn_countLuuTru();
          this.fn_recountLuuTru();
        }
        if (loaiDiemDen == "entertainment") {
          this.fn_countGiaiTri();
          this.fn_recountGiaiTri();
        } else if (loaiDiemDen == "ticket") {
          this.fn_countVeDienTu();
          this.fn_recountVeDienTu();
        } else if (loaiDiemDen == "yellow_page_place") {
          this.fn_countDiemDen();
          this.fn_recountDiemDen();
        } else if (loaiDiemDen == "tourist_carriers") {
          this.fn_countDiemDen();
          this.fn_recountDiemDen();
          this.fn_countVanTaiKhach();
          this.fn_recountVanTaiKhach();
        }
      }
    } else if (MethodService.checkRole("TourAgent")) {
      this.fn_countPhanHoi();
      this.fn_recountPhanHoi();
      this.fn_countTour();
      this.fn_recountTour();
    }

    if (MethodService.checkRole("SafePlace")) {
      const donViCungCapRes = await DonViCungCapApi.findById(
        diemDenAnToanRes.result[0].id
      );
      const donViCungCapChoDuyetRes = await DonViCungCapChoDuyetApi.findById(
        diemDenAnToanRes.result[0].id
      );
      if (
        donViCungCapChoDuyetRes.result &&
        donViCungCapChoDuyetRes.result.du_lieu_khai_bao.user_ten &&
        donViCungCapChoDuyetRes.result.du_lieu_khai_bao.chuc_vu &&
        donViCungCapChoDuyetRes.result.du_lieu_khai_bao.user_loai &&
        !donViCungCapRes.result
      ) {
        this.$confirm(
          "Tài khoản của bạn vẫn đang trong quá trình chờ duyệt. Vui lòng liên hệ 0906150276 để được hỗ trợ",
          {
            confirmButtonText: "Đóng",
            showCancelButton: false,
            type: "warning",
          }
        );
      } else if (!donViCungCapChoDuyetRes.result && !donViCungCapRes.result) {
        // if (
        //   diemDenAnToanRes.result[0].loai_diem_den == "restaurant" ||
        //   diemDenAnToanRes.result[0].loai_diem_den == "hotel" ||
        //   diemDenAnToanRes.result[0].loai_diem_den == "entertainment" ||
        //   diemDenAnToanRes.result[0].loai_diem_den == "ticket" ||
        //   diemDenAnToanRes.result[0].loai_diem_den == "tourist_carriers"
        // ) {
        this.$router.push({
          name: "Admin-ChinhSachVaQuyenLoi-infomation",
        });
        // }
      }
    } else if (MethodService.checkRole("TourAgent_Pending")) {
      this.$confirm("Tài khoản của bạn vẫn đang trong quá trình chờ duyệt.", {
        confirmButtonText: "Đóng",
        showCancelButton: false,
        type: "warning",
      });
    }

    this.forceUpdateUI();
  },
  watch: {
    "$store.state.phanHoi.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countPhanHoi();
        this.forceUpdateUI();
      }
    },
    "$store.state.dichVuDiemDen.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countDichVuDiemDen();
        this.forceUpdateUI();
      }
    },
    "$store.state.dichVuLuuTru.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countDichVuLuuTru();
        this.forceUpdateUI();
      }
    },
    "$store.state.dichVuAmThuc.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countDichVuAmThuc();
        this.forceUpdateUI();
      }
    },
    "$store.state.dichVuGiaiTri.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countDichVuGiaiTri();
        this.forceUpdateUI();
      }
    },
    "$store.state.dichVuVeDienTu.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countDichVuVeDienTu();
        this.forceUpdateUI();
      }
    },
    "$store.state.dichVuVanTaiKhach.refreshFnCountNew": function (
      newVal,
      oldVal
    ) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countDichVuVanTaiKhach();
        this.forceUpdateUI();
      }
    },
    "$store.state.diemDen.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countDiemDen();
        this.forceUpdateUI();
      }
    },
    "$store.state.tourDuLich.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countTour();
        this.forceUpdateUI();
      }
    },
    "$store.state.luuTru.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countLuuTru();
      }
    },
    "$store.state.amThuc.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countAmThuc();
        this.forceUpdateUI();
      }
    },
    "$store.state.giaiTri.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countGiaiTri();
        this.forceUpdateUI();
      }
    },
    "$store.state.veDienTu.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countVeDienTu();
        this.forceUpdateUI();
      }
    },
    "$store.state.vanTaiKhach.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countVanTaiKhach();
        this.forceUpdateUI();
      }
    },
    "$store.state.quangCao.refreshFnCountNew": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_countAds();
        this.forceUpdateUI();
      }
    },
    "$store.state.menu.refreshFnCount": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_getNav();
        this.forceUpdateUI();
      }
    },
    "$store.state.check.checkDVCC": function (newVal, oldVal) {
      let _this = this;
      if (newVal && newVal != oldVal) {
        _this.fn_checkHaveDVCC();
        this.forceUpdateUI();
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 992px) {
  ::v-deep .app-body .sidebar {
    height: calc(100vh - 96px) !important;
  }
}

@media (max-width: 991.98px) {
  ::v-deep .app-footer {
    position: relative;
  }

  ::v-deep .sidebar {
    position: fixed;
    z-index: 1019;
    width: 250px;
    height: calc(100vh - 96px);
  }
}

@media (max-width: 767px) {
  ::v-deep .sidebar {
    position: fixed;
    z-index: 1019;
    width: 250px;
    height: calc(100vh - 46px);
  }

  .footer h5 {
    font-size: 14px;
  }

  .footer p {
    font-size: 12px !important;
  }
}
</style>
